<script>
    import Select from "svelte-select/Select.svelte";

    import { NotificationModal, PageLoading } from "./index.svelte";

    import {
        getNumber,
        getOptionLabelForSurgeon,
        isObjectEmpty,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import { prePopulateAccountOptions } from "../../stores";

    import { cacheAccountPrePopulateSearchOptions } from "../../Utils/utilCache.svelte";

    import { DateInput } from "./index.svelte";

    export let isModalOpen = false,
        showDoctorSelector = false,
        showDateInput = false,
        showSurgeonSelector = false,
        accountId,
        fromCalendar = false,
        listProp = {},
        closeModal = () => {},
        onUploaded = async () => {};

    $: isSubmitButtonDisabled =
        isObjectEmpty(fileObj) ||
        (showDoctorSelector &&
            (!selectedDoctor || isObjectEmpty(selectedDoctor))) ||
        // (showDateInput && !dateInputData) ||
        // (showSurgeonSelector &&
        //     (!selectedSurgeon || isObjectEmpty(selectedSurgeon))) ||
        (!showDoctorSelector && !accountId) ||
        isUploadingFile;

    $: if (isModalOpen) setTimeout(() => enableFileDragAndDrop(), 0);
    else disableFileDragAndDrop();

    $: if (isModalOpen && accountId && !showDoctorSelector)
        syncAccountDoctors(accountId);

    let isUploadingFile = false,
        fileInput,
        fileObj = {},
        selectedDoctor,
        dateInputData,
        selectedSurgeon,
        isLoadingAccountDoctors = false,
        accountDoctors = [],
        surgeonOptions = [];

    let uploadResObj = {},
        isAfterUploadFileModalOpen = false;

    const enableFileDragAndDrop = () => {
        const enableDropArea = document.getElementById("enableDropArea");
        const uploadDoctorPdfModal = document.getElementById(
            "uploadDoctorPdfModal",
        );

        uploadDoctorPdfModal.addEventListener("dragover", function (e) {
            e.preventDefault();

            enableDropArea.classList.add("outline-dashed");
            enableDropArea.classList.add("outline-secondary");
            enableDropArea.classList.add("outline-2");
        });

        uploadDoctorPdfModal.addEventListener("dragleave", function (e) {
            enableDropArea.classList.remove("outline-dashed");
            enableDropArea.classList.remove("outline-secondary");
            enableDropArea.classList.remove("outline-2");
        });

        uploadDoctorPdfModal.addEventListener("drop", function (e) {
            e.preventDefault();

            enableDropArea.classList.remove("outline-dashed");
            enableDropArea.classList.remove("outline-secondary");
            enableDropArea.classList.remove("outline-2");
        });

        enableDropArea.addEventListener("drop", function (e) {
            e.preventDefault();

            if (isUploadingFile) return;

            onFileChange(e, true);

            this.classList.remove("outline-dashed");
            this.classList.remove("outline-secondary");
            this.classList.remove("outline-2");
        });
    };

    const disableFileDragAndDrop = () => {
        const enableDropArea = document.getElementById("enableDropArea");

        enableDropArea &&
            enableDropArea.removeEventListener("drop", onFileChange);
    };

    const onFileChange = (e, isDropFile = false) => {
        if (isUploadingFile) return;

        const inputField = document.getElementById("fileNamePlaceholder");

        const file = isDropFile ? e.dataTransfer.files[0] : e.target.files[0];

        const fileType = file?.type;

        if (
            !fileType ||
            (fileType !== "application/pdf" &&
                fileType !== "image/jpeg" &&
                fileType !== "image/png")
        )
            return;

        inputField.innerText = file.name;

        const fileName = _getFileName(file, fileType);

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            fileObj = {
                name: fileName,
                type: fileType,
                content: e.target.result.split(",")[1],
            };
        };
    };

    const handleSelectDoctor = async () => {
        if (!selectedDoctor || isObjectEmpty(selectedDoctor)) return;

        const { id: doctorId } = selectedDoctor;

        await syncAccountDoctors(doctorId);
    };

    const loadDoctors = async (filterText) => {
        await cacheAccountPrePopulateSearchOptions();

        if (!filterText)
            return $prePopulateAccountOptions.length
                ? $prePopulateAccountOptions
                : [];

        return $prePopulateAccountOptions
            ? $prePopulateAccountOptions.filter(({ value }) =>
                  value.toLowerCase().includes(filterText.toLowerCase()),
              )
            : [];
    };

    const clearFilterDoctor = () => {
        selectedDoctor = null;
        selectedSurgeon && clearFilterSurgeon();
    };

    const clearFilterSurgeon = () => (selectedSurgeon = null);

    const groupBy = (option) => option.groupName;

    const syncAccountDoctors = async (dId) => {
        accountDoctors = [];
        surgeonOptions = [];
        clearFilterSurgeon();

        isLoadingAccountDoctors = true;

        await apiMethods.getMethod
            .getAccountDoctors(0, 999999, {
                "filter[doctorId]": dId,
            })
            .then((res) => {
                if (!res || res.error) {
                    showError(
                        res.error ??
                            "Failed to load surgeons, please refresh the page and try again and contact support if the issue persists.",
                    );
                    accountDoctors = [];
                    surgeonOptions = [];
                    clearFilterSurgeon();
                } else accountDoctors = [...res.results];
            });

        let uniqueAccountDoctors = [
            ...new Map(accountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        let suggestedAccountDoctors = [];

        await apiMethods.getMethod.getSuggestedSurgeon(dId).then((res) => {
            if (res.results) suggestedAccountDoctors = [...res.results];
        });

        //filter surgeons and take only once by unique id
        suggestedAccountDoctors = [
            ...new Map(suggestedAccountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        suggestedAccountDoctors = suggestedAccountDoctors.slice(
            0,
            Math.min(suggestedAccountDoctors.length, 5),
        );

        if (!suggestedAccountDoctors?.length)
            uniqueAccountDoctors.map((doctor) => {
                surgeonOptions.push({
                    ...doctor,
                    displayLabel: getOptionLabelForSurgeon(doctor),
                    matchingId: `${doctor.id}${doctor.state}`,
                });
            });
        else {
            const suggestedSurgeonUniqueIds = [];
            const len = Math.min(suggestedAccountDoctors.length, 5);

            for (let i = 0; i < len; i++) {
                const surgeon = suggestedAccountDoctors[i];

                surgeonOptions.push({
                    ...surgeon,
                    groupName: "Suggested surgeons",
                    displayLabel: getOptionLabelForSurgeon(surgeon),
                    matchingId: `${surgeon.id}${surgeon.state}`,
                });

                suggestedSurgeonUniqueIds.push(surgeon.providerUniqueId);
            }

            uniqueAccountDoctors.map((surgeon) => {
                if (
                    !suggestedSurgeonUniqueIds.includes(
                        surgeon.providerUniqueId.toString(),
                    )
                )
                    surgeonOptions.push({
                        ...surgeon,
                        groupName: "Other Surgeons",
                        displayLabel: getOptionLabelForSurgeon(surgeon),
                        matchingId: `${surgeon.id}${surgeon.state}`,
                    });
            });
        }

        isLoadingAccountDoctors = false;

        surgeonOptions = [...surgeonOptions];
    };

    const uploadFile = async () => {
        isUploadingFile = true;

        const pdfObj = {
            name: "list.pdf",
            extension: "pdf",
            content: fileObj.content,
        };

        pdfObj.accountId = Number(
            showDoctorSelector ? selectedDoctor.key : accountId,
        );

        if (fromCalendar && listProp && !isObjectEmpty(listProp)) {
            const { hospitalId, surgeonId } = listProp;

            pdfObj.requestedDateTime = listProp.fromTime
                ? `${listProp.fromDate}T${listProp.fromTime}`
                : listProp.fromDate;
            pdfObj.requestedHospitalId = hospitalId;
            pdfObj.requestedSurgeonId = surgeonId;
        } else {
            if (showSurgeonSelector && selectedSurgeon && selectedSurgeon.id)
                pdfObj.requestedSurgeonId = selectedSurgeon.id;

            if (showDateInput && dateInputData)
                pdfObj.requestedDateTime = dateInputData;
        }

        await apiMethods.postMethod
            .uploadAccountSchedulePDF(pdfObj)
            .then((res) => _handleUploadPDF(res))
            .catch((err) => showError(err, null, true));

        cancelPostFile();

        isUploadingFile = false;
    };

    const cancelPostFile = () => {
        closeModal();

        fileObj = {};
        clearFilterDoctor();
        dateInputData = null;

        const inputField = document.getElementById("fileNamePlaceholder");
        if (inputField) inputField.innerText = "";

        const fileInput = document.getElementById("fileInput");
        if (fileInput) fileInput.value = "";
    };

    const confirmAfterUploadFile = () => {
        handleRedirectToEncounterTable("all");
        // _closeAfterUploadFileModal(true)
    };

    const handleRedirectToEncounterTable = (type = "") => {
        let url = `/#/PatientEncounter/page=0&size=25&encounterId=`;

        switch (type) {
            case "created":
                if (!uploadResObj.createdEncounters.length) return;
                url += uploadResObj.createdEncounters.join(",");
                break;
            case "updated":
                if (!uploadResObj.updatedEncounters.length) return;
                url += uploadResObj.updatedEncounters.join(",");
                break;
            case "removed":
                if (!uploadResObj.removedEncounters.length) return;
                url += uploadResObj.removedEncounters.join(",");
                break;
            case "skipped":
                if (!uploadResObj.skippedEncounters.length) return;
                url += uploadResObj.skippedEncounters.join(",");
                break;
            case "all":
                const allEncounters = [
                    ...uploadResObj.createdEncounters,
                    ...uploadResObj.updatedEncounters,
                    ...uploadResObj.removedEncounters,
                    ...uploadResObj.skippedEncounters,
                ];
                if (!allEncounters.length) return;
                url += allEncounters.join(",");
                break;
            default:
                break;
        }

        window.open(url, "_blank");
    };

    // HELPER FUNCTIONS
    const _handleUploadPDF = (res) => {
        if (!res || res.error)
            showError(
                "Failed to upload pdf to selected doctor, please refresh the page and try again and contact support if the issue persists.",
            );
        else _openAfterUploadFileModal(res);
    };

    const _openAfterUploadFileModal = (res = {}) => {
        if (typeof res === "string") res = JSON.parse(res);

        if (!isObjectEmpty(res)) uploadResObj = { ...res };

        isAfterUploadFileModalOpen = true;
    };

    const _closeAfterUploadFileModal = async (triggerOnUploaded = false) => {
        isAfterUploadFileModalOpen = false;

        if (triggerOnUploaded || fromCalendar) {
            const allEncounters = [
                ...uploadResObj.createdEncounters,
                ...uploadResObj.updatedEncounters,
                ...uploadResObj.removedEncounters,
                ...uploadResObj.skippedEncounters,
            ];

            await onUploaded(allEncounters);
        }

        uploadResObj = {};
    };

    const _getDisplayValue = (value) => {
        if (value || value == 0) return getNumber(value);
        else return "Missing value";
    };

    const _getFileName = ({ name }, type) => name;

    $: hideEncounterNumbers =
        uploadResObj.totalEncountersCreated == 0 &&
        uploadResObj.totalEncountersUpdated == 0 &&
        uploadResObj.totalEncountersRemoved == 0 &&
        uploadResObj.totalEncountersSkipped == 0;
</script>

<NotificationModal
    title="Upload List PDF"
    {isModalOpen}
    isConfirming={isUploadingFile}
    showCancelBtn={false}
    showConfirmBtn={false}
    contentClass="p-6 flex flex-col"
    closeModalFunction={cancelPostFile}
    customizeId="uploadDoctorPdfModal"
    zIndex={99999}
    btnOptions={[
        {
            text: "Cancel",
            class: "btn btn-accent",
            loading: isUploadingFile,
            function: () => cancelPostFile(),
        },
        {
            text: isUploadingFile ? "Uploading" : "Upload",
            loading: isUploadingFile || isSubmitButtonDisabled,
            function: () => uploadFile(),
        },
    ]}
>
    <div class="flex flex-col flex-1 gap-4" id="enableDropArea">
        {#if isUploadingFile}
            <PageLoading />
        {:else}
            {#if showDoctorSelector}
                <div class="w-full mt-2">
                    <Select
                        bind:value={selectedDoctor}
                        on:clear={clearFilterDoctor}
                        on:select={handleSelectDoctor}
                        loadOptions={loadDoctors}
                        itemId="key"
                        label="value"
                        noOptionsMessage="No Doctors Found"
                        placeholder="Search / Select Doctor"
                        --border-radius="10px"
                    />
                </div>
            {/if}

            {#if showDateInput}
                <DateInput
                    bind:value={dateInputData}
                    wrapperClass="input input-sm px-0 input-bordered w-full"
                    wrapperClassFocus="inputFocus"
                    placeholder="Date"
                    showClearButton
                    showTime
                />
            {/if}

            {#if showSurgeonSelector}
                <div class="w-full mt-2">
                    <Select
                        bind:value={selectedSurgeon}
                        on:clear={clearFilterSurgeon}
                        items={surgeonOptions}
                        itemId="matchingId"
                        label="displayLabel"
                        {groupBy}
                        noOptionsMessage="No Surgeons Found"
                        placeholder="Search / Select Surgeon"
                        --border-radius="10px"
                        disabled={isLoadingAccountDoctors ||
                            (showDoctorSelector &&
                                (!selectedDoctor ||
                                    isObjectEmpty(selectedDoctor)))}
                    />
                </div>
            {/if}

            <div class="flex flex-1 text-[#000]">
                <p
                    id="fileNamePlaceholder"
                    class="w-1/2 pt-2 pl-2 border-2 rounded-tl-lg rounded-bl-lg text-secondary"
                />
                <button
                    class="w-1/2 p-2 rounded-tr-lg rounded-br-lg bg-[#E8E8E8] text-secondary text-sm {isUploadingFile
                        ? 'cursor-not-allowed'
                        : 'cursor-pointer'}"
                    on:click|preventDefault={() =>
                        !isUploadingFile && fileInput.click()}
                >
                    Select or drag and drop here
                </button>
                <input
                    type="file"
                    accept=".pdf, .jpg, .png, .jpeg"
                    style="display: none"
                    id="fileInput"
                    on:change={onFileChange}
                    bind:this={fileInput}
                />
            </div>
        {/if}
    </div>
</NotificationModal>

<NotificationModal
    title="Upload complete"
    isModalOpen={isAfterUploadFileModalOpen}
    showCancelBtn={false}
    showConfirmBtn={false}
    closeModalFunction={_closeAfterUploadFileModal}
    modalMaxWidth="max-w-4xl"
    btnOptions={[
        {
            function: () => confirmAfterUploadFile(),
            text: "Review",
            class: `${hideEncounterNumbers ? "hidden" : ""}`,
        },
        {
            function: () => _closeAfterUploadFileModal(),
            text: "Done",
        },
    ]}
>
    <div class="flex flex-col gap-y-2">
        {#if !hideEncounterNumbers}
            <div class="flex flex-1 items-center gap-x-4">
                <p class="title">Encounters Created:</p>
                <p
                    class="flex-1 {uploadResObj.totalEncountersCreated > 0
                        ? 'underline cursor-pointer'
                        : ''}"
                    on:click|preventDefault={() =>
                        handleRedirectToEncounterTable("created")}
                >
                    {_getDisplayValue(uploadResObj.totalEncountersCreated)}
                </p>
            </div>

            <div class="flex flex-1 items-center gap-x-4">
                <p class="title">Encounters Updated:</p>
                <p
                    class="flex-1 {uploadResObj.totalEncountersUpdated > 0
                        ? 'underline cursor-pointer'
                        : ''}"
                    on:click|preventDefault={() =>
                        handleRedirectToEncounterTable("updated")}
                >
                    {_getDisplayValue(uploadResObj.totalEncountersUpdated)}
                </p>
            </div>

            <div class="flex flex-1 items-center gap-x-4">
                <p class="title">Encounters Removed:</p>
                <p
                    class="flex-1 {uploadResObj.totalEncountersRemoved > 0
                        ? 'underline cursor-pointer'
                        : ''}"
                    on:click|preventDefault={() =>
                        handleRedirectToEncounterTable("removed")}
                >
                    {_getDisplayValue(uploadResObj.totalEncountersRemoved)}
                </p>
            </div>

            <div class="flex flex-1 items-center gap-x-4">
                <p class="title">Encounters Skipped:</p>
                <p
                    class="flex-1 {uploadResObj.totalEncountersSkipped > 0
                        ? 'underline cursor-pointer'
                        : ''}"
                    on:click|preventDefault={() =>
                        handleRedirectToEncounterTable("skipped")}
                >
                    {_getDisplayValue(uploadResObj.totalEncountersSkipped)}
                </p>
            </div>
        {/if}

        {#if uploadResObj.emailReport}
            <div class="overflow-y-auto">
                {@html uploadResObj.emailReport}
            </div>
        {/if}
    </div>
</NotificationModal>

<style>
    .title {
        line-height: 1.5rem;
        font-size: 1rem;
        font-weight: 700;
        min-width: 10rem;
    }
</style>
